import React from 'react';

import { Button, Card, FormItem, FormLayout, Radio, Spacing } from '@vkontakte/vkui';

import { FeedbackFormProps } from './types';

export const FeedbackForm: React.FC<FeedbackFormProps> = ({ hasUserAgreed, onRadioChange, shareResult }) => {
  return (
    <div style={{ margin: '0 16px' }}>
      <Card mode="shadow" style={{ padding: '6px 10px' }}>
        <FormLayout>
          <FormItem top="Согласны ли Вы с результатом?">
            <Radio
              name="radio"
              value="yes"
              checked={typeof hasUserAgreed === 'boolean' && hasUserAgreed}
              onChange={async () => await onRadioChange(true)}
            >
                  Да
            </Radio>
            <Radio
              name="radio"
              value="no"
              checked={typeof hasUserAgreed === 'boolean' && !hasUserAgreed}
              onChange={async () => await onRadioChange(false)}
            >
                  Нет
            </Radio>
          </FormItem>
        </FormLayout>
      </Card>

      <>
        <Spacing size={24} />

        <Button
          stretched
          size="l"
          mode="primary"
          onClick={shareResult}
        >
                      Поделиться результатом
        </Button>
      </>
    </div>
  );
};
